// extracted by mini-css-extract-plugin
export default {"background":"style_background__k6U+d","main":"style_main__W9McE","close":"style_close__IMbUo","img":"style_img__F6YzD","title":"style_title__ZsyJf","btn":"style_btn__4VHC2"};